<template>
  <div class="shareContainer">

    <div style="position: sticky;width:
                         100%;background:
                         #f8f8f8;
                         top:0">
      <van-tabs v-model="active"
                animated
                @change="onChange(active)">
        <!-- 首次切到月分享 默认月份传获取的当前月-->
        <van-tab v-for="index in shareList"
                 :key="index.name"
                 :title="index.title"></van-tab>
      </van-tabs>

      <div id="bgc_item"
           v-if="activeType==2||orderList.length > 0">
        <div class="bgc_share_number">分享数量：{{totalNumber}}人</div>
        <div class="flex bgc_share_mounth"
             v-if="activeType==2">
          <div class="fontWeight">
            月份
          </div>

          <div style="margin-left: 8px;">
            <div class="monthItem"
                 @click="onDataChange">
              <div>
                {{isChooseDate}}
              </div>
              <van-icon name="arrow-up"
                        v-if="showmonthData"
                        size="12px"
                        color="#c8c8c8"
                        style="width: 12px;height: 12px;" />
              <van-icon name="arrow-down"
                        v-else
                        size="12px"
                        color="#c8c8c8"
                        style="width: 12px;height: 12px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="AgentIsShow == true ?'scrollAgent':'scroll'"
         v-if="orderList.length !== 0">
      <!-- 分享人数 和月份-->
      <div id="share_bottom_box">
        <!-- 分页 -->
        <van-list v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了~"
                  @load="onLoad"
                  :immediate-check="false"
                  class="cardList">
          <div v-for="item in orderList"
               :key="item.id">
            <div class="shareList"
                 @click="onClickDetail(item)">
              <div class="everylist flex">
                <div class="shareAvatar"
                     v-if="item.avatarUrl">
                  <img :src="item.avatarUrl"
                       class="avatar_img"
                       alt="" />
                </div>
                <div class="shareAvatar"
                     v-else>
                  <img class="avatar_img"
                       src="../../../assets/images/default.jpeg"
                       alt="" />
                </div>
                <div style="width: 100%;">
                  <div class="between betweenBottom">
                    <div class="flex">
                      <svg class="iconSize"
                           aria-hidden="true">
                        <use xlink:href="#icon-weixinnichengtubiao"></use>
                      </svg>
                      <div class="nickName">{{item.penrsonName}}</div>
                    </div>
                    <div>
                      下单商品数：{{item.numberOfGoods}}
                    </div>
                  </div>
                  <div class="between">
                    <div class="flex">
                      <svg class="iconSize"
                           aria-hidden="true">
                        <use xlink:href="#icon-shoujitubiao"></use>
                      </svg>
                      <div class="leftList"> {{item.phoneNumber}}</div>
                    </div>
                    <div class="updateColor">查看详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- 空页面 -->
    <div class="noShares"
         v-if="orderList.length == 0">
      <div class="nullPage">
        <img src="../../../assets/images/update.png"
             alt />
      </div>
      <div v-if="!firstLoading"
           class="noShareText">暂无分享</div>
      <!-- <van-loading v-else type="spinner" /> -->
      <button class="share_button _button"
              @click="onClickShare()">
        立即分享
      </button>
    </div>
    <!-- <div class="businessCard" style="position: relative;"> -->
    <van-popup v-model="IsDetailShow"
               class="popupBorder">
      <DetailPop v-if="IsDetailShow"
                 :msg="msg"></DetailPop>
      <div class="DetailPopTitle"
           v-if="IsDetailtitleShow">
        <div class="orderDetailPosition">下单商品详情</div>
        <van-icon name="cross"
                  @click="onDetailClose"
                  color="#999"
                  size="18px"
                  style="position: absolute;z-index: 10;top: 16px;right: 16px;" />
      </div>
    </van-popup>
    <CheckUserAccount v-if="IsAccountShow"
                      :key="nowTime"
                      @change="changAccount($event)"></CheckUserAccount>
    <!-- </div> -->
    <van-popup v-model="showmonthData"
               round
               position="bottom">
      <van-picker show-toolbar
                  :columns="monthData"
                  :default-index="defaultIndex"
                  @confirm="onConfirm"
                  @cancel="onCancel" />
    </van-popup>
    <!-- 我的切换账号按钮 -->
    <div class="my_share_btn"
         v-if="subSubmit"
         @click="switchAccounts()">
      切换账号
    </div>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker
} from "vant";
import loading from "../../components/loading/loading";
// import service from "../../api/order/index";
import { mapGetters } from "vuex";
import DetailPop from "../../components/empOrderDetailPop/index";
import service from "../../api/myShare/index";
import CheckUserAccount from "../../components/checkUserAccout/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    loading,
    DetailPop,
    CheckUserAccount
  },
  data () {
    return {
      IsAccountShow: false,
      IsDetailAccountShow: false,
      nowTime: '',
      accountMessage: '',
      changAccountType: false,
      msg: '',   //传值
      showmonthData: false, //是否显示月份
      IsDetailShow: false, //下单商品详情弹窗显示隐藏
      IsDetailtitleShow: false, //下单商品详情标题显示隐藏
      totalNumber: 0,
      monthData: [],
      isChooseDate: '五月',
      defaultIndex: 0, //月份初始位置
      activeName: '0',
      firstLoading: false,
      isLoading: true, //loading状态
      active: 0,
      activeType: 0,
      shareList: [
        { name: 0, title: "总分享" },
        { name: 1, title: "月分享" }
      ],
      orderList: [],
      detailPage: 1, //详情分页
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      subSubmit: false
    };
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow () {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },

  },
  mounted () {
    this.IsDetailtitleShow = false
    this.init();
    this.getFullMonth();
    this.getIsShowSwitch();
  },
  methods: {
    getIsShowSwitch () {
      service.isShowSwitch().then(res => {
        if (res.statusCode == 200) {


          this.subSubmit = res.data

        } else {
          Toast(res.errors)
        }
      })
    },
    // 子调父
    changAccount (value) {
      console.log(value, 111)
      // 调取接口  
      if (value.subUserId !== '' && value.subUserId !== null & value.subUserId !== undefined) {
        if (value.clearItem) {
          this.changAccountType = true
          this.UserId = value.subUserId
          this.orderList = []
          this.init();
        } else {
          this.totalNumber = 0
          this.dateTime = '--'
        }

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0


      }
    },
    // 切换账号
    switchAccounts () {
      this.IsAccountShow = true
      this.IsDetailAccountShow = true
      this.nowTime = new Date().getTime()
    },
    // 获取年月
    getFullMonth () {
      service.dateForEmployee().then(res => {
        if (res.statusCode == 200) {
          res.data.map(i => {
            i.text = this.getMonth(i.date)
            i.disabled = !i.isTrue
            if (i.isCurrent == true) {
              this.isChooseDate = this.getMonth(i.date)
              this.defaultIndex = i.date - 1
            }
          })
          this.monthData = res.data
        } else {
          Toast(res.errors);
        }
      })
    },
    // 点击显示日期弹窗
    onDataChange () {
      this.showmonthData = true
    },
    // 显示商品详情弹窗
    onClickDetail (item) {

      this.msg = item.userId
      service
        .detail(this.msg, this.detailPage, this.pageSize)
        .then((res) => {
          if (res.statusCode == 200) {
            if (res.data.items.length == 0) {
              this.IsDetailShow = false
              Toast('无下单商品')
            } else {
              // 传值给详情页
              this.IsDetailShow = true
              setTimeout(() => {
                this.IsDetailtitleShow = true
              }, 600);
              console.log(item, 287)
            }
          } else {
            this.IsDetailShow = false
            Toast(res.errors)
          }
        })
        .catch((error) => {
          this.IsDetailShow = false
          // Toast(error)
        });

    },
    // 关闭详情
    onDetailClose () {
      this.IsDetailShow = false
    },
    // 分享
    onClickShare () {
      // this.IsDetailShow = true
      this.$router.push('shareCode')
    },
    // 确认月份
    onConfirm (value, index) {
      this.isChooseDate = value.text
      this.defaultIndex = index
      this.showmonthData = false
      // 选择月份查询 月份的数据
      this.activeType = 2
      this.isLoading = true;
      this.orderList = [];
      this.page = 1;
      this.firstLoading = true;
      this.loading = true;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.items;
          this.totalNumber = orderList.personNumber;
          this.firstLoading = false;
          this.loading = false;
          this.finished = false;
          if (orderList.totalCount <= this.orderList.length) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    onCancel () {
      this.showmonthData = false
    },
    // 切换
    onChange (active) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
      this.getIsShowSwitch();
      console.log(active, 308)
      if (active == 0) {
        this.activeType = 1
      }
      if (active == 1) {
        this.activeType = 2
      }
      this.isLoading = true;
      this.orderList = [];
      this.page = 1;
      this.firstLoading = true;
      this.loading = true;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.items;
          this.totalNumber = orderList.personNumber;
          this.firstLoading = false;
          this.loading = false;
          this.finished = false;
          if (orderList.totalCount <= this.orderList.length) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    // 年月转换 // date 数字类型
    getMonth (month) {
      switch (month) {
        case 1:
          return "一月";
        case 2:
          return "二月";
        case 3:
          return "三月";
        case 4:
          return "四月";
        case 5:
          return "五月";
        case 6:
          return "六月";
        case 7:
          return "七月";
        case 8:
          return "八月";
        case 9:
          return "九月";
        case 10:
          return "十月";
        case 11:
          return "十一月";
        case 12:
          return "十二月";
        default:
          break;
      }
    },
    // 获取列表
    init () {
      this.activeType = 1
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.items;
          this.totalNumber = orderList.personNumber;
          this.finished = false;
          this.firstLoading = false;
          if (orderList.totalCount <= this.orderList.length) {
            this.finished = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getList () {
      return new Promise((resolve, reject) => {
        var month = 0
        if (this.activeType == 1) {
          month = 0

        }
        if (this.activeType == 2) {
          month = this.defaultIndex + 1
        }
        console.log(this.activeType, 388)
        if (this.changAccountType == true) {
          service
            .switchAccounForEmployeeList(this.activeType, month, this.page, this.pageSize, this.UserId)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              this.totalNumber = 0
              // reject();
            });
        } else {

          service
            .servicePersonForEmployeeList(this.activeType, month, this.page, this.pageSize)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              // reject();
            });
        }


      });
    },
    onLoad () {
      this.page++;
      this.getList().then((orderList) => {
        this.isLoading = false;
        this.orderList = this.orderList.concat(orderList.items);
        this.totalNumber = orderList.personNumber;
        this.loading = false;
        this.finished = false;
        if (orderList.totalCount <= this.orderList.length) {
          this.finished = true;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';
#share_bottom_box {
  padding-bottom: 60px;
}
.avatar_img {
  border-radius: 50%;
  width: 48px;
  height: 48px;
}
.bgc_share_number {
  float: left;
}
.bgc_share_mounth {
  float: right;
  margin-right: 16px;
}
#bgc_item {
  height: 42px;
  line-height: 42px;
  padding-left: 16px;
  background: #f8f8f8;
  padding: 8px 16px;
}
.my_share_btn {
  width: 351px;
  margin: 0 12px;
  text-align: center;
  height: 40px;
  background: #f00724;
  border-radius: 8px;
  position: fixed;
  bottom: 24px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
.shareContainer {
  width: 100%;
  min-height: 100vh;
  // padding-bottom: 60px;
  //   overflow-y: scroll;
  //
  //   position: fixed;
  // height: calc(100% - 0.7vw);
  background: #f8f8f8;
  // font-size: 14px;8;
  // font-size: 14px;

  @{deep}.van-tab__text--ellipsis {
    color: #999;
  }

  // 折叠版样式
  @{deep}.van-collapse-item__wrapper {
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  @{deep} .van-cell {
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    padding: 1.87vw 4.26667vw;
  }

  // .scroll {
  //   // margin-top: 104px;
  // }
  .scrollAgent {
    margin-top: 104px;
    margin-bottom: 48px;
  }

  .DetailPopTitle {
    background: #fff;
    height: 50px;
    // line-height: 50px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .monthItem {
    width: 70px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e6e6e6;
    padding: 0 14px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .noShares {
    width: 100%;
    text-align: center;
    font-size: 3.2vw;
    color: #92909a;
    padding-top: 104px;
  }

  .noShareText {
    padding-top: 24px;
  }

  .orderDetailPosition {
    position: absolute;
    z-index: 10;
    top: 16px;
    left: 50%;
    width: 100px;
    margin-left: -50px;
    font-size: 16px;
    font-weight: 600;
  }

  .month {
    border-bottom: 1px solid #ebedf0;
    height: 80px;
    overflow: auto;
  }

  .nickName {
    font-weight: 600;
    margin-left: 6px;
    width: 85px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .leftList {
    margin-left: 6px;
  }

  // 分享头像
  .shareAvatar {
    width: 48px;
    height: 48px;
  }

  .between {
    margin-left: 16px;
    margin-right: 16px;
  }

  .everylist {
    .between {
      margin-left: 12px;
      margin-right: 0;
    }
  }

  .betweenBottom {
    margin-bottom: 8px;
  }

  .shareList {
    margin: 0px 16px 8px 16px;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 1px #ebebeb;
    border: 0.5px solid #e6e6e6;
  }

  @{deep}.van-tab--active .van-tab__text--ellipsis {
    color: #f00724;
    font-weight: 600;
  }

  .share_button {
    width: 80px;
    height: 32px;
    background: #f00724;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    border: 0;
    margin-top: 24px;
  }

  @{deep} .van-tabs__nav .van-tabs__line {
    height: 2px;
  }

  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 48px;
    //   padding: 2vw 0;
    background: #fff;
  }
}
</style>